import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Trash2, Plus } from "lucide-react";

import { FIELD_RENDERERS } from "./fieldRenderers";

export default function ArrayInput({
  field,
  value = [],
  onChange,
}) {
  const itemFields = field.itemFields ?? [];

  const buildDefaultRow = () =>
    itemFields.reduce((row, item) => {
      row[item.key] = item.defaultValue ?? "";
      return row;
    }, {});

  const addRow = () => {
    onChange([...value, buildDefaultRow()]);
  };

  const updateRow = (rowIndex, key, newValue) => {
    const rows = [...value];

    rows[rowIndex] = {
      ...rows[rowIndex],
      [key]: newValue,
    };

    onChange(rows);
  };

  const removeRow = (rowIndex) => {
    onChange(value.filter((_, index) => index !== rowIndex));
  };

  return (
    <div className="space-y-4">
      {value.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="rounded-lg border p-4 space-y-4"
        >
          <div className="grid gap-4 md:grid-cols-2">
            {itemFields.map((item) => {
              const Component = FIELD_RENDERERS[item.type];

              const {
                key,
                type,
                label,
                description,
                required,
                helperText,
                ...inputProps
              } = item;

              return (
                <div key={key} className="space-y-2">
                  <label
                    htmlFor={`${field.key}-${rowIndex}-${key}`}
                    className="text-sm font-medium"
                  >
                    {label}

                    {required && (
                      <span className="ml-1 text-destructive">*</span>
                    )}
                  </label>

                  {Component ? (
                    <Component
                      id={`${field.key}-${rowIndex}-${key}`}
                      field={item}
                      value={row[key]}
                      onChange={(value) =>
                        updateRow(rowIndex, key, value)
                      }
                      {...inputProps}
                    />
                  ) : (
                    <Input
                      id={`${field.key}-${rowIndex}-${key}`}
                      value={row[key] ?? ""}
                      onChange={(e) =>
                        updateRow(
                          rowIndex,
                          key,
                          e.target.value
                        )
                      }
                    />
                  )}

                  {description && (
                    <p className="text-xs text-muted-foreground">
                      {description}
                    </p>
                  )}

                  {helperText && (
                    <p className="text-xs text-muted-foreground">
                      {helperText}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          <Button
            type="button"
            variant="destructive"
            onClick={() => removeRow(rowIndex)}
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Remove
          </Button>
        </div>
      ))}

      <Button
        type="button"
        variant="outline"
        onClick={addRow}
      >
        <Plus className="mr-2 h-4 w-4" />
        {field.addButtonLabel ?? "Add"}
      </Button>
    </div>
  );
}